/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Continue_GoogleInputs */

const en_login_continue_google = /** @type {(inputs: Login_Continue_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

const ar_login_continue_google = /** @type {(inputs: Login_Continue_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المتابعة مع Google`)
};

/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Login_Continue_GoogleInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const login_continue_google = /** @type {((inputs?: Login_Continue_GoogleInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Continue_GoogleInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_continue_google(inputs)
	return ar_login_continue_google(inputs)
});